import { createEntryApi, updateEntryApi } from '@/api/entries';

import moment from 'moment';

export const publishEntry =
  ({
    blogSlug,
    entryId,
    targetBlog,
    tags,
    hotUpdateTagList,
    isPinned,
    unpinEntryIfPinned,
    pinEntry,
    requestFields,
    updatePublishAt,
    removeEntryDraft,
    token,
    navigate
  }) =>
  async dispatch => {
    let res;
    if (entryId && entryId !== '0') {
      res = await updateEntryApi({
        data: {
          ...requestFields,
          ...(updatePublishAt ? { publishedAt: moment().toISOString() } : {})
        },
        entryId,
        token
      });
    } else {
      res = await createEntryApi({
        ...requestFields,
        targetBlog,
        token
      });
    }

    if (res.error) {
      console.error(res.error);
      window.alert('не получилось сохранить запись :( ');
      return false;
    } else {
      if (tags.length) {
        hotUpdateTagList(tags);
      }

      if (isPinned) {
        await pinEntry(res.data.id);
      } else {
        unpinEntryIfPinned(res.data.id);
      }

      removeEntryDraft();

      setTimeout(() => {
        if (entryId && entryId !== '0') {
          navigate(`/blog/${blogSlug}/${entryId}`);
        } else {
          navigate(`/blog/${blogSlug}/`);
        }
      }, 100);
      return true;
    }
  };
